<template>
    
    <span class="badge" :class="css">
        <slot></slot>
    </span>

</template>

<script>

const TYPES = [
    'primary',
    'secondary',
    'success',
    'info',
    'notice',
    'danger',
    'warning',
]

export default {

    props: {
        type: String
    },

    computed: {

        css: function () {

            if ( !TYPES.includes(this.type) ) {
                throw new Error('Type `' + this.type + '` inconnu')
            }

            return 'badge--' + this.type
        }
    }
}
</script>

<style>

.badge {
    display: block;
    padding: 0.25em 0.4em;
    margin-top: 0.25em;
    font-size: 85%;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    border-radius: 0.25rem;
    width: fit-content;
}

.badge.badge--primary {
    background-color: #007bff;
}

.badge.badge--secondary {
    background-color: #6c757d;
}

.badge.badge--success {
    background-color: #28a745;
}

.badge.badge--info {
    background-color: #17a2b8;
}

.badge.badge--notice {
    color: #fff;
    background-color: #ffc107;
}

.badge.badge--warning {
    color: #fff;
    background-color: #fc7c26;
}

.badge.badge--danger {
    background-color: #dc3545;
}

.badge > .fa,
.badge > i,
.badge > * {
    color: inherit;
}

</style>